function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.178,
  d: "M6.79656991,14.1969771 L2.48094498,12.6850232 C2.48094498,12.6850232 1.49930491,12.1582393 2.3408817,11.5246586 C3.18245849,10.8922779 18.9353873,2.2753409 18.9353873,2.2753409 C18.9353873,2.2753409 20.1337065,1.43176665 19.9876576,2.69772801 C19.8823109,3.61210011 17.813684,16.7648987 17.813684,16.7648987 C17.813684,16.7648987 17.7777703,18.065659 16.7243029,17.6780709 C15.6732298,17.2916826 11.7789918,15.9213245 11.7789918,15.9213245 L9.21715067,20 C9.21715067,20 8.76104717,20 8.76104717,19.5776129 C8.76104717,19.1564257 8.72633063,15.2877438 8.72633063,15.2877438 C8.72633063,15.2877438 8.90111045,14.6541631 9.11180393,14.4081706 C9.32249741,14.1621782 17.0750597,5.7228357 17.0750597,5.7228357"
});

function SvgIconPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaperPlane);
export default __webpack_public_path__ + "static/media/icon_paper_plane.95d7161f.svg";
export { ForwardRef as ReactComponent };